import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import Scenes from '@/components/Scenes'
import Products from '@/components/Products'
import Time from '@/components/Time'
import Survey from '@/components/Survey'
import error403 from '@/components/error403'
import Auth from '@okta/okta-vue'

Vue.use(Router)
Vue.use(Auth, {
    issuer: process.env.ISSUER_OKTA,
    client_id: process.env.CLIENT_ID_OKTA,
    redirect_uri: process.env.REDIRECT_URI_OKTA,
    scope: 'openid profile email'
})

const router = new Router({
    mode: 'history',
    routes: [{
            path: '/implicit/callback',
            component: Auth.handleCallback()
        },
        {
            path: '/',
            name: 'Dashboard',
            component: Dashboard,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/products',
            name: 'Products',
            component: Products,
            meta: {
                requiresAuth: true
            },
            props: (route) => ({
                graph: parseInt(route.query.graph)
            })
        },
        {
            path: '/time',
            name: 'Time',
            component: Time,
            meta: {
                requiresAuth: true
            },
            props: (route) => ({
                graph: parseInt(route.query.graph)
            })
        },
        {
            path: '/error403',
            name: 'error403',
            component: error403,
            meta: {
                requiresAuth: true
            },
            props: (route) => ({
                graph: parseInt(route.query.graph)
            })
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
})

router.beforeEach(Vue.prototype.$auth.authRedirectGuard())

export default router


// WEBPACK FOOTER //
// ./src/router/index.js